import { Component, OnInit, AfterViewInit, ViewChildren, ViewChild } from '@angular/core';
import { UploadMultiFileComponent } from 'src/app/shared/components/upload-multi-file/upload-multi-file.component';
import { EnterpriseTypes } from 'src/app/core/constants/enterprise-type';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { EnterpriseService } from 'src/app/core/services/enterprise.service';
import { DatePipe } from '@angular/common';
import { CommonService } from 'src/app/core/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import { Message } from 'src/app/core/class/message';
import { CustomerFilterLanguage } from 'src/app/core/class/customer-filter-language';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material';
import { ConfirmIndentifyComponent } from '../confirm-indentify/confirm-indentify.component';
import {environment} from "../../../../../../../environments/environment";
import { EnvService } from 'src/app/core/services/env.service';
import { format } from 'date-fns';
@Component({
  selector: 'app-view-enterprise',
  templateUrl: './view-enterprise.component.html',
  styleUrls: ['./view-enterprise.component.scss']
})
export class ViewEnterpriseComponent extends BaseComponent implements OnInit, AfterViewInit {

  @ViewChildren('focus') focus;
  @ViewChild(UploadMultiFileComponent, { read: UploadMultiFileComponent, static: false }) uploadMultiFileComponent;
  personalId = EnterpriseTypes.PERSONAL;
  viewFormGroup: FormGroup;
  type: any;
  certificate: any;
  status: string;
  defaultAddress = {
    cityId: null,
    districtId: null,
    wardId: 1,
    enterpriseId: null,
    address: '',
    isNewAddress: true
  };
  enterpriseType: [{
    id: number,
    name: '',
    langs: []
  }];
  certificateType: any;
  representativeCertificateType: any;
  representativeCertificate: any;
  representativeCertificateName: any;
  enterprisesDefaut = {
    id: null,
    name: '',
    enterpriseType: null,
    tenantId: 1,
    foreignName: '',
    parentId: null,
    abbreviation: '',
    taxCode: '',
    licenceDate: null,
    activeDate: null,
    phone: '',
    fax: '',
    primaryEmail: '',
    email: '',
    certificateId: null,
    certificateNo: '',
    issuedDate: null,
    issuedAt: '',
    expiryDate: null,
    accountNumber: '',
    accountName: '',
    bankName: '',
    bankBranch: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeIssuedDate: null,
    representativeIssuedOn: '',
    representativeIssuedAt: '',
    status: true,
    birthday: null,
    sex: '',
    adminUser: '',
    businessType: null,
    addresses: [
      {
        address: '',
        cityId: null,
        districtId: null,
        wardId: null,
        id: null,
        isNewAddress: true
      }
    ],
    cityId: null,
    wardId: null,
    districtId: null,
    attachments: [],
    birthdayDisplay: '',
    representativeIssuedDateDisplay: '',
    issuedDateDisplay: ''
  };

  addresses = {
    cityName: '',
    districtName: '',
    wardName: ''
  };
  enterpriseId: string;
  checkCertificateType = false;

  subscription: Subscription;
  cityList: any[] = []
  districtList: any[] = []
  wardList: any[] = []
  searchtenantId: '';
  searchPage: number;
  searchPageSize: number;
  searchEnterpriseId: '';
  searchTaxCode: '';
  searchStatus: [];
  searchTypes: number;
  searchKeyword: '';
  listBankName: any[] = []
  enterprises = this.enterprisesDefaut;
  cities: { id: number, name: '', description: '' }[];
  districts: { id: number, cityId: number, name: '', description: '' }[];
  selectedDistricts: { id: number, cityId: number, name: '', description: '' }[];
  wards: { id: number, districtId: number, name: '', description: '' }[];
  selectWards: { id: number, districtId: number, name: '', description: '' }[];
  sme_hub:any
  categoryLoaded = false;
  enterpriseLoaded = false;

  constructor(
    private enterpriseService: EnterpriseService,
    private datePipe: DatePipe,
    public commonService: CommonService,
    private route: ActivatedRoute,
    private breadcrumbsService: BreadcrumbsService,
    private router: Router,
    public message: Message,
    public customerFilter: CustomerFilterLanguage,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private env:EnvService
  ) {
    super(commonService, message);
    this.sme_hub = env.sme_portal_url
  }

  ngOnInit() {
    this.enterpriseId = localStorage.getItem('enterpriseId');

    // this.loadCities();
    // this.loadDistricts();
    // this.loadWards();
    this.getBankName();

    // goi song song: API chi tiet doanh nghiep khong phai cho 5 api dia danh;
    // phan doi chi dia chi (ten tinh/huyen/xa) duoc tinh khi ca 2 xong
    this.commonService.getCategory().subscribe(result => {
      this.cityList[1] = result[0].data.filter(item => !item.isNew)
      this.districtList[1] = result[1].data.filter(item => !item.isNew)
      this.wardList[1] = result[2].data.filter(item => !item.isNew);
      this.cityList[0] = result[3].data
      this.districtList[0] = []
      this.wardList[0] = result[4].data;
      this.cities = result[0].data;
      this.districts = result[1].data;
      this.wards = result[2].data;
      this.categoryLoaded = true;
      this.resolveAddressNames();
    })
    this.loadData(this.enterpriseId);

    window.scrollTo(0, 0);
    this.breadcrumbsService.store([
      { label: 'breadcrumbs.home', url: 'analysis-report', params: [], highlight: false },
      { label: 'breadcrumbs.enterprise_manage', url: 'main', params: [], highlight: false },
      {
        label: 'breadcrumbs.enterprise_detail',
        url: 'view-enterprise',
        params: [this.route.snapshot.paramMap.get('id')],
        highlight: false
      },
    ]);

    this.subscription = this.route
      .queryParams
      .subscribe(params => {
        // Defaults to 0 if no query param provided.
        this.searchtenantId = params.tenantId || 0;
        this.searchPage = params.page || 0;
        this.searchPageSize = params.pageSize || 0;
        this.searchEnterpriseId = params.enterpriseId || '';
        this.searchTypes = params.types;
        this.searchStatus = params.status;
        this.searchTaxCode = params.taxCode || '';
        this.searchKeyword = params.keyword || '';
      });
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focus.first.nativeElement.focus());
  }
  getBankName() {
    this.commonService.getBankName().subscribe(rs => {
      if (rs && rs.data) {
        var result = rs.data;
        this.listBankName = result;
      }
    });
  }

  loadData(enterpriseId: string) {
    this.enterpriseService.getEnterpriseByID(enterpriseId).subscribe(rs => {
      localStorage.setItem('SignDataValidateKyc', JSON.stringify(rs.data));
      if (rs != null && rs.data != null) {
        const responsedData = rs.data;
        if (responsedData.addresses == null || responsedData.addresses.length === 0) {
          responsedData.addresses = [this.defaultAddress];
        }
        this.enterprises = responsedData;
        this.enterprises.birthdayDisplay = this.enterprises.birthday ? format(this.enterprises.birthday, 'DD/MM/YYYY') : '';
        this.enterprises.representativeIssuedDateDisplay = this.enterprises.representativeIssuedDate ? format(this.enterprises.representativeIssuedDate, 'DD/MM/YYYY') : '';
        this.enterprises.issuedDateDisplay = this.enterprises.issuedDate ? format(this.enterprises.issuedDate, 'DD/MM/YYYY') : '';
        this.enterprises.addresses[0].isNewAddress = !!responsedData.addresses[0].isNewAddress;
        // const bankSelect = this.listBankName.find(bank => bank.brandName === this.enterprises.bankName);
        // if (bankSelect) {
        //   this.enterprises.bankName = bankSelect.vietnameseName;
        // }
        this.enterpriseLoaded = true;
        this.resolveAddressNames();

        this.getEnterpriseType();
        this.getCertificateType();
        this.getRepresentativeCertificateType();
      } else {
        this.enterprises = this.enterprisesDefaut;
      }
    });
  }

  /**
   * Doi chi ten tinh/huyen/xa: chi tinh khi co ca du lieu doanh nghiep va danh muc dia danh
   */
  resolveAddressNames() {
    if (!this.enterpriseLoaded || !this.categoryLoaded) {
      return;
    }
    if(this.enterprises.addresses[0].isNewAddress){
      this.cities = this.cityList[0]
      this.districts = this.districtList[0]
      this.wards = this.wardList[0]
    } else {
      this.cities = this.cityList[1]
      this.districts = this.districtList[1]
      this.wards = this.wardList[1]
    }
    if (this.enterprises.addresses.length > 0) {
      var cityItem = (this.enterprises.addresses[0].cityId != null) ? this.cities.find(x => x.id === this.enterprises.addresses[0].cityId) : undefined;
      var districtItem = (this.enterprises.addresses[0].districtId != null) ? this.districts.find(x => x.id === this.enterprises.addresses[0].districtId) : undefined;
      var wardItem = (this.enterprises.addresses[0].wardId != null) ? this.wards.find(x => x.id === this.enterprises.addresses[0].wardId) : undefined;
      this.addresses = {
        cityName: (cityItem != undefined) ? cityItem.name : '',
        districtName: (districtItem != undefined) ? districtItem.name : '',
        wardName: (wardItem != undefined) ? wardItem.name : ''
      };
    } else {
      this.addresses = {
        cityName: '',
        districtName: '',
        wardName: ''
      }
    }
  }

  /**
   * Get cities list from local storage or api
   */
  loadCities() {
    if (localStorage.getItem('cities') === null) {
      this.getCitiesRedis().subscribe(rs => {
        const data = rs.data;
        if (data != null && data.length > 0) {
          this.cities = data;
          localStorage.setItem(
            'cities',
            JSON.stringify(this.cities),
          );
        }
      });
    } else {
      this.cities = JSON.parse(
        localStorage.getItem('cities')
      );
    }
  }

  /**
   * Get districts list from local storage or api
   */
  loadDistricts() {
    if (localStorage.getItem('districts') === null) {
      this.getDistrictsRedis().subscribe(rs => {
        const data = rs.data;
        if (data != null && data.length > 0) {
          this.districts = data;
          localStorage.setItem(
            'districts',
            JSON.stringify(this.districts),
          );
        }
      });
    } else {
      this.districts = JSON.parse(
        localStorage.getItem('districts')
      );
    }
  }

  /**
   * Get wards list from local storage or api
   */
  loadWards() {
    if (localStorage.getItem('wards') === null) {
      this.getWardsRedis().subscribe(rs => {
        const data = rs.data;
        if (data != null && data.length > 0) {
          this.wards = data;
          localStorage.setItem(
            'wards',
            JSON.stringify(this.wards),
          );
        }
      });
    } else {
      this.wards = JSON.parse(
        localStorage.getItem('wards')
      );
    }
  }

  onBackClick(route: string) {
    this.router.navigate([route], {
      queryParams: {
        tenantId: this.searchtenantId,
        page: this.searchPage,
        pageSize: this.searchPageSize,
        enterpriseId: this.searchEnterpriseId,
        taxCode: this.searchTaxCode,
        status: this.searchStatus,
        types: this.searchTypes,
        keyword: this.searchKeyword
      }
    });
  }

  onUpdateClick(route: string, id: string) {
    if(JSON.parse(localStorage.getItem('permissions')).includes(1) && localStorage.getItem('isFromSSO') =='true'){
      // window.location.href = 'http://10.207.252.76:8777/admin/thong-tin-doanh-nghiep';
      window.open(this.sme_hub+'/admin/thong-tin-doanh-nghiep','_blank');
      return
    }

    if (this.enterprises.enterpriseType === this.personalId && !this.checkCertificateType) {
      const dialogRe = this.dialog.open(ConfirmIndentifyComponent, {
        width: '600px',
        data: {
          message: this.message.getMessage('kyc.choose_identify'),
          enterpriseType: this.enterprises.enterpriseType,
          personalId: this.personalId,
          checkCertificateType: this.checkCertificateType
        }
      });

      dialogRe.afterClosed().subscribe((rs) => {
        if (rs) {
          console.log("close")
        }
      });
    }
    else {
      this.router.navigate([route], {
        queryParams: {
          tenantId: this.searchtenantId,
          // page: this.searchPage,
          // pageSize: this.searchPageSize,
          enterpriseId: this.searchEnterpriseId,
          // taxCode: this.searchTaxCode,
          // status: this.searchStatus,
          // types: this.searchTypes,
          // keyword: this.searchKeyword
        }
      });
    }


  }

  /**
   * Get enterprise type list
   */
  getEnterpriseType() {
    this.commonService.getEnterpriseType().subscribe(rs => {
      if (rs && rs.data) {
        this.enterpriseType = rs.data;
        this.type = this.enterpriseType.find(x => x.id === this.enterprises.enterpriseType).langs;
      }
    });
  }

  /**
   * Get certificate list
   */
  getCertificateType() {
    this.commonService.getCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        this.certificateType = rs.data;
        if (this.enterprises.enterpriseType !== this.personalId) {
          this.certificate = this.certificateType.find(x => x.id === this.enterprises.certificateId).langs;
        }
      }
    });
  }

  /**
   * Get representative certificate list
   */
  getRepresentativeCertificateType() {
    this.commonService.getRepresentativeCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        this.representativeCertificateType = rs.data;
        this.commonService.getCertificateType().subscribe(rs2 => {
          if (rs2 && rs2.data) {
            // Concat list getCertificateType and getRepresentativeCertificateType
            this.representativeCertificateType = this.representativeCertificateType.concat(rs2.data);
            if (this.enterprises.enterpriseType === this.personalId) {
              this.representativeCertificate = this.representativeCertificateType.find(x => x.id === this.enterprises.certificateId);
              // check ẩn KYC với cá nhân có loại giấy tờ khác
              if (this.representativeCertificate.id === 30003) {
                this.checkCertificateType = true;
              }
            } else {
              // tslint:disable-next-line:max-line-length
              this.representativeCertificate = this.representativeCertificateType.find(x => x.id === this.enterprises.representativeCertificateId);
            }
            this.representativeCertificateName = this.representativeCertificate !== undefined ? this.representativeCertificate.langs : '';
          }
        });
      }
    });
  }

  getEnterpriseTypeOptions(options) {
    const data = this.customerFilter.filterOptionsData(options);
    if (data !== undefined && data !== null) {
      return data;
    }
    else {
      return '';
    }
  }
}
